import React from "react";
import { RenderOnlyFor } from "@ignitesales/neuro-application";
import BasicFooter from "../../core-components/BasicFooter.jsx";
import {
    SummaryPageSubtitle,
    SummaryPageTitle,
} from "../../core-components/ProductPageMessages";
import ContactShareButtons from "../../core-components/ContactShareButtons";
import DialogueProductWrapper from "../../core-components/DialogueProductWrapper";
import { CollapsibleAnswersList } from "../../index.js";
import ReturnToSurveyButton from "../../core-components/ReturnToSurveyButton";
import ActionButtonContainer from "../../core-components/ActionButtonContainer";
import useRecommendedProductActionTrigger from "../../hooks/useRecommendedProductActionTrigger.mjs";

function SummaryPage({ componentClass, productsList }) {
    useRecommendedProductActionTrigger(productsList);
    return (
        <div className={componentClass} id={componentClass}>
            <div className="container">
                <div className={`${componentClass}__header`}>
                    <div>
                        <SummaryPageTitle tagName="h1" />
                        <SummaryPageSubtitle tagName="p" />
                    </div>
                    <div className="header-buttons">
                        <RenderOnlyFor forSummaryPage={true}>
                            <ContactShareButtons isLeftAligned={true} />
                            <ActionButtonContainer
                                position="top"
                                page="SummaryPage"
                            ></ActionButtonContainer>
                        </RenderOnlyFor>
                        <RenderOnlyFor forDetailsPage={true}>
                            <ActionButtonContainer
                                position="top"
                                page="DetailsPage"
                            ></ActionButtonContainer>
                        </RenderOnlyFor>
                    </div>
                </div>

                <div className={`${componentClass}__products`}>
                    {productsList.map((p) => (
                        <DialogueProductWrapper key={p.id} product={p} />
                    ))}
                </div>

                <div className={`${componentClass}__actions`}>
                    <RenderOnlyFor forSummaryPage={true}>
                        <ActionButtonContainer
                            position="bottom"
                            page="SummaryPage"
                        ></ActionButtonContainer>
                    </RenderOnlyFor>
                    <RenderOnlyFor forDetailsPage={true}>
                        <ActionButtonContainer
                            position="bottom"
                            page="DetailsPage"
                        ></ActionButtonContainer>
                    </RenderOnlyFor>
                </div>

                <CollapsibleAnswersList
                    className={`${componentClass}__answers`}
                />
                <ReturnToSurveyButton
                    className={`${componentClass}__navigation`}
                />
            </div>
            <BasicFooter />
        </div>
    );
}

export default SummaryPage;
